import { HTMLAttributes } from 'react'
import { cva, VariantProps } from 'class-variance-authority'

import Section from '@/components/base/section'

import { cn } from '@/lib/utils'

const spacerVariants = cva(['border-0 bg-transparent'], {
  variants: {
    variant: {
      sm: 'pt-[1.6rem] md:pt-[3.2rem]',
      md: 'pt-[3.2rem] md:pt-[6.4rem]',
      lg: 'pt-[4.8rem] md:pt-[9.6rem]',
      xl: 'pt-[5.6rem] md:pt-[11.2rem]',
      '2xl': 'pt-[12rem] md:pt-[24rem]'
    }
  },
  defaultVariants: {
    variant: 'md'
  }
})

export type SpacerProps = HTMLAttributes<HTMLHRElement> &
  VariantProps<typeof spacerVariants>

const Spacer = ({ className, variant, ...props }: SpacerProps) => {
  return (
    <Section
      asChild
      className={cn(spacerVariants({ variant, className }))}
      {...props}
    >
      <hr />
    </Section>
  )
}

export default Spacer
